import { render, staticRenderFns } from "./project_warnings.vue?vue&type=template&id=a1994a88&scoped=true&"
import script from "./project_warnings.vue?vue&type=script&lang=js&"
export * from "./project_warnings.vue?vue&type=script&lang=js&"
import style0 from "./project_warnings.vue?vue&type=style&index=0&id=a1994a88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1994a88",
  null
  
)

/* custom blocks */
import block0 from "./project_warnings.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports